export default __webpack_public_path__ + "static/media/whatsapp.c339ff50.png";